
function Footer() {
  
  return (
    <footer>
        <div className="h-[100px] border-t mt-5">
          <div className="copyright py-4 mt-5 text-center">
            <div className="container">
              <small>Copyright &copy; Stylencode</small>
            </div>
          </div>
        </div>
      </footer>
  );
}

export default Footer;
